export default [
    {
        path: '/',
        component: () => import('@/components/HeaderAndFooterV2.vue'),
        children: [
            {
                path: 'reset-password',
                name: 'reset-password',
                component: () => import('./ResetPassword.vue')
            
            },
             {
                path: 'resetting-password',
                name: 'resetting-password',
                component: () => import('./ResettingPassword.vue')
            
            },
        ]
    }
             
]